// @ts-nocheck

import React, { useEffect, useState } from "react";
import { UploadFile } from "antd/lib/upload/interface";
import { PAGES } from "./constants";
import * as sagaActions from "./sagaActions";
import { useDispatch } from "react-redux";
import { setActivePage } from "./reducer";
import GridCsvUploadModal from "./gridCsvUploadModal";
import _ from "lodash";
import * as constants from "./constants";
import { fetchTableColumns } from "models/tableColumns/sagaActions";
import { Button,Tooltip } from "antd";

interface Props {
  visible: boolean;
  onCancel: () => void;
  onUpload: ({ file, params }: { files: UploadFile; params: any }) => void;
  height?: number;
}

const GridCsvUpload: React.FC<Props> = (props) => {
  const [isGridUpload, setGridUpload] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!isGridUpload) {
      dispatch(setActivePage({ activePage: PAGES.UPLOAD }));
    }
    dispatch(
      sagaActions.triggerFetchUploadMetadata({ tableId: props?.parentTableId })
    );
  }, [dispatch, isGridUpload, props?.parentTableId]);

  useEffect(() => {
    if (props.isAvailability) {
      dispatch(fetchTableColumns(constants.UPLOAD_MODEL_ID));
    }
  }, [dispatch, props.isAvailability]);

  const onUploadComplete = React.useCallback(() => {
    setGridUpload(false);
  }, []);

  return (
    <>
     <Tooltip title="Import Data">
       <Button className="menu-action--button" onClick={() => setGridUpload(true)} icon={<i className="icon-export" />} />
      </Tooltip> 
      {isGridUpload && (
        <GridCsvUploadModal
          onUploadComplete={onUploadComplete}
          onClose={() => {
            setGridUpload(false);
          }}
          {...props}
        />
      )}
    </>
  );
};

export default GridCsvUpload;
